const VerticalRule = ({classExt}) => {
    return(<div className={`vertical_rule${classExt?` ${classExt}`:""}`}> </div>)
}

export default VerticalRule;